<template>
     <div id="app" v-bind:class="{ upcoming: selectedTab == CurrentTab.UPCOMING }">   
      <h1 class="hidden">Probable banker - staticstical soccer probability predictions</h1>
    <div class="container">
      <img src="img/probablebanker_optimized.svg" alt="" class="logo"/>
      <!-- <img src="img/probablebanker_plain.svg" alt="" class="logo"/> -->
      <!-- <svg id="main_logo" height="100%" width="100%" -->
      <!--      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" > -->
      <!-- <image x="0" y="0" height="100%" width="100%" xlink:href="img/probablebanker_plain_2.svg"/> -->
      <!-- </svg> -->
      
          <!--<transition name="fade" mode="out-in">-->

        <Info v-if="showInfo" key="showInfo">
        </Info>
        <div v-else key="showGames">
            <!-- League Selector -->
            <div class="row tac light-green">
                <ul class="leagues">
                    <li v-for="league in leagues" v-bind:class="['league', league.name]" v-bind:key="league._id">
                        <a href="" v-on:click.prevent="selectLeague(true, league.name)" v-bind:class="{ active: activeLeague==league.name }">
                            {{ league.name }}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="games row light-green">
                <a href="" @click.prevent="selectedTab=CurrentTab.UPCOMING; selectLeague(true, activeLeague)" v-bind:class="['upcoming-link', { active: selectedTab==CurrentTab.UPCOMING }]">UPCOMING</a>
                <a href="" @click.prevent="selectedTab=CurrentTab.HISTORY; selectLeague(true, activeLeague)" v-bind:class="['upcoming-link',  { active: selectedTab==CurrentTab.HISTORY }]">HISTORY</a>
                <a href="" @click.prevent="selectedTab=CurrentTab.STATS; selectLeague(true, activeLeague)" v-bind:class="['upcoming-link',  { active: selectedTab==CurrentTab.STATS }]">STATS</a>
                <a href="" @click.prevent="selectedTab=CurrentTab.FAQ; selectLeague(true, activeLeague)" v-bind:class="['upcoming-link',  { active: selectedTab==CurrentTab.FAQ }]">FAQ</a>
            </div>
            <!-- Heading row -->
            <div class="games row header light-green" v-if="typeof(activeGames) === 'undefined' || activeGames === null || activeGames.length > 0">
                <div class="col col-2"></div>
                <div class="col col-3 oddsblocks header">
                    <div class="oddsblock one-third tac">1</div>
                    <div class="oddsblock one-third tac">X</div>
                    <div class="oddsblock one-third tac">2</div>
                </div>
                <div class="col col-1"></div>
            </div>
            <div class="game row" v-else>
                <div class="col col-6 tac italic" v-if="selectedTab==CurrentTab.UPCOMING">Games to be added soon</div>
                <!--<div class="col col-6 tac italic" v-if="selectedTab==CurrentTab.UPCOMING">Waiting for season 2021-2022 to start.</div>-->
                <div class="col col-6 tac italic" v-else>No history</div>
            </div>
            <div class="sticky">
                <div class="sticky-wrapper">
                    <div class="games loading" v-if="loading">
                        <!-- Games are loading -> show loading image -->
                    </div>
                    <div class="games error tac col col-6" v-else-if="errorMsg.length > 0">
                        {{ this.errorMsg }}
                    </div>
                    <div class="games test" v-else>
                        <!-- Show stats -->
                        <stats v-if="selectedTab==CurrentTab.STATS" :selectedLeague="activeLeague" :activeGames="activeGames"></stats>
                        <FAQ v-else-if="selectedTab==CurrentTab.FAQ"></FAQ>
                        <!-- Loop through active games -->
                        <game v-else v-for="(gameItem) in activeGames" :game="gameItem" :upcoming="(selectedTab==CurrentTab.UPCOMING ? true : false)"  :activedate="activeDate" :toggled="false" :toggledDates="toggledDates" :key="gameItem._id" @update-date="updateCurrentDate" @toggle-date="toggleCurrentDate"></game>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Footer -->
    <footer>Copyright © 2020 ProbableBanker. All rights reserved. <a href="" @click.prevent="showInfo=!showInfo;">Info</a>
    </footer>
  </div>
</template>

<script>

// Import components
import Game from './components/Game.vue'
import Stats from './components/Stats.vue'
import Info from './components/Info.vue'
import FAQ from './components/FAQ.vue'
//import io from 'socket.io-client';
import Pusher from 'pusher-js'

/*
const CurrentTab = {
  UPCOMING: 0,
  HISTORY: 1,
  STATS: 2,
  FAQ: 3,
  LOGIN: 4,
};
*/  
const CurrentTab = Object.freeze({ UPCOMING: 0, HISTORY: 1, STATS: 2, FAQ: 3 });
export default {
  name: 'App',
  
  components: {
    Game,
    Stats,
    Info,
    FAQ
  },
  data () {
        return {
            games: null,
            activeGames: null,
            leagues: null,
            /* upcoming: true, */
            CurrentTab,
            selectedTab: CurrentTab.UPCOMING, 
            showInfo: false,
            activeLeague: '',
            toggledDates: [],
            loading: true, 
            errorMsg: '',
            channel: '',
            pusher: null, 
            leagueArray: ['EN1', 'EN2', 'DE', 'IT', 'ES', 'FR']
            //socket : io('localhost:8080')
        }
    },
    methods: {
        /* Change league or upcoming / history */
        selectLeague(reset, leagueName){
            this.showInfo = false;  
            if (reset) {      
                this.activeDate = '';          
                this.activeLeague = leagueName;
                // If league not selected yet, by default open a league with upcoming games
                if(leagueName.length == 0 ) {
                    let tempGames = [];
                    let i = 0;               
                    while ( tempGames.length == 0 && i < this.leagueArray.length ) {
                        tempGames = this.games.filter(game => {
                           return (game.league.toLowerCase().includes(this.leagueArray[i].toLowerCase()) && ( game.homeGoals == -1))
                        })
                        i++;
                    }
                    if ( tempGames.length > 0 ) {
                        leagueName = this.leagueArray[i-1];
                    } else {
                        leagueName = this.leagueArray[0];
                    }
                }
                this.activeLeague = leagueName;
                this.toggledDates = [];
            } 
            this.filterGames(reset);
            return this.activeGames;
        },     
        updateCurrentDate(activeDate) {
            this.activeDate = activeDate;
        },
        filterGames(reset) {
            if (this.games !== null) { // Make sure games are loaded before trying to filter
                this.activeGames = this.games.filter(game => {
                    /* return (game.league.toLowerCase().includes(this.activeLeague.toLowerCase()) && ( (this.upcoming ? game.homeGoals == -1 : game.homeGoals > -1))) */
                    return (game.league.toLowerCase().includes(this.activeLeague.toLowerCase()) && ( ((this.selectedTab == CurrentTab.UPCOMING) ? game.homeGoals == -1 : game.homeGoals > -1)))
                })
            }
            if (this.activeGames !== null && reset) { // Make sure games are loaded and you want to reset
                /* if( !this.upcoming && this.activeGames.length > 0 ) { */
                if( (this.selectedTab != CurrentTab.UPCOMING ) && this.activeGames.length > 0 ) {
                    this.toggleCurrentDate(this.activeGames[0].gameDate);
                }
            }
        },
        toggleCurrentDate(activeDate) {
            if( this.toggledDates.indexOf(activeDate) > -1 ) {
                let newArray = this.toggledDates.splice(this.toggledDates.indexOf(activeDate), 1);
                return newArray;
            } else {
                let newArray = this.toggledDates.push(activeDate);
                return newArray;
            }
        }   
    },
    destroyed () {
        this.channel = this.pusher.unbind();
        
    },
    created () {
        this.pusher = new Pusher('8900d8acf9ff540e4493', {
            cluster: 'eu'
        });
        let vm = this; // This is to be used inside bind (in bind this refers to pusher)
        /*this.socket.on('changeData', (data) => {
            let index = vm.games.findIndex(el => el._id === data._id); // Find updated index
            vm.games[index] = data; // Update item that has changed
            vm.selectLeague(vm.activeLeague); // Update view
        });*/
        this.channel = this.pusher.subscribe('games');
        this.channel.bind('updated', (data) => {
            console.log('pusher: ' + data.homeTeam + data.awayTeam);
            // In upcoming, don't worry about dates
            //if ( !vm.upcoming ) {
            if ( this.selectedTab != CurrentTab.UPCOMING ) {
                // If there are no games for this date -> add date
                let dateIndex = vm.activeGames.findIndex(el => el.gameDate === data.gameDate);
                if (  dateIndex == -1) {
                    vm.updateCurrentDate('');
                } else {
                    let tmpDate = new Date(data.gameDateIndex);
                    tmpDate.setSeconds( tmpDate.getSeconds() - 1 );
                    data.gameDateIndex = tmpDate.toISOString();
                    vm.updateCurrentDate(data.gameDate);
                }
            }
            let index = vm.games.findIndex(el => el._id === data._id); // Find updated index
            if ( index > -1 ) {
                // Update event occured
                vm.games[index] = data; // Update item that has changed
            } else {
                // Insert event occured
                vm.games.push(data);
                
            }
            // In upcoming, don't worry about dates
            //if ( !vm.upcoming ) {
                vm.games.sort(function(a,b){
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(b.gameDateIndex) - new Date(a.gameDateIndex);
                });
            //}
            vm.selectLeague(false, vm.activeLeague); // Update view   
        });
    },
    mounted () {
        this.$http
            .get('/api/games')
            .then((response) => {
                this.games = response.data
                this.selectLeague(true, '')
                this.loading = false;
            })
            .catch(error => { this.errorMsg = 'Error loading games (' + error + '). Please try again later.';  })
            //.finally(() => this.loading = false)
        this.$http
            .get('/api/leagues')
            .then(response => (this.leagues = response.data))
            .catch(error => { this.errorMsg = 'Error loading games (' + error + '). Please try again later.';  })
           //.finally(() => this.loading = false)
        
    }  
}
</script>

<style>
.app {
    margin: 0 auto;
    max-width: 1200px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: green;
}
</style>
